import { Mail, Phone } from "lucide-react";

const TwitchIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 2H3v16h5v4l4-4h5l4-4V2zM11 11V7M16 11V7" />
  </svg>
);

const InstagramIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const YoutubeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
    <path d="m10 15 5-3-5-3z" />
  </svg>
);

const socialLinks = [
  { key: "instagram", icon: InstagramIcon, label: "Instagram", hoverColor: "hover:text-pink-400" },
  { key: "facebook", icon: FacebookIcon, label: "Facebook", hoverColor: "hover:text-blue-400" },
  { key: "tiktok", icon: TikTokIcon, label: "TikTok", hoverColor: "hover:text-cyan-300" },
  { key: "youtube", icon: YoutubeIcon, label: "YouTube", hoverColor: "hover:text-red-400" },
  { key: "twitch", icon: TwitchIcon, label: "Twitch", hoverColor: "hover:text-purple-400" },
];

export const Footer = ({ profile }) => {
  const currentYear = new Date().getFullYear();
  const links = profile.social_links || {};

  return (
    <footer className="relative" data-testid="footer">
      <div className="section-glow-divider" />
      <div className="mx-auto max-w-[var(--page-max)] px-4 md:px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo + Copyright */}
          <div className="flex items-center gap-3">
            <img
              src={profile.logo_footer || profile.logo_url}
              alt="TYLEGN Logo"
              className="w-8 h-8 object-contain"
              width="32"
              height="32"
              loading="lazy"
            />
            <span className="text-sm text-muted-foreground">
              &copy; {currentYear} Tylegn Gaming and Entertainment. All rights reserved.
            </span>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-3">
            <a
              href={`mailto:${profile.email}`}
              className="text-muted-foreground hover:text-primary transition-colors duration-200"
              aria-label="Send email"
              data-testid="footer-social-link-email"
            >
              <Mail className="w-5 h-5" />
            </a>
            <a
              href={`tel:${profile.phone}`}
              className="text-muted-foreground hover:text-primary transition-colors duration-200"
              aria-label="Call phone"
              data-testid="footer-social-link-phone"
            >
              <Phone className="w-5 h-5" />
            </a>
            {socialLinks.map(({ key, icon: Icon, label, hoverColor }) =>
              links[key] ? (
                <a
                  key={key}
                  href={links[key]}
                  target="_blank"
                  rel="noreferrer"
                  className={`text-muted-foreground ${hoverColor} transition-colors duration-200`}
                  aria-label={label}
                  data-testid={`footer-social-link-${key}`}
                >
                  <Icon className="w-5 h-5" />
                </a>
              ) : null
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
